/**
 * Google Analytics 4 helpers — Ohio Accident Aid.
 *
 * gtag is loaded in /public/index.html. We disabled auto page_view there so
 * SPA route changes can be tracked accurately via React Router.
 */

const GA_MEASUREMENT_ID = "G-PXHY8FLTEJ";

function _hasGtag() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

/** Fire a GA4 pageview. Pass the current pathname + search. */
export function trackPageview(path, title) {
  if (!_hasGtag()) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || (typeof document !== "undefined" ? document.title : ""),
    page_location: typeof window !== "undefined" ? window.location.href : "",
    send_to: GA_MEASUREMENT_ID,
  });
}

/** Fire a custom GA4 event with the given name + params. */
export function trackEvent(eventName, params = {}) {
  if (!_hasGtag()) return;
  window.gtag("event", eventName, { ...params, send_to: GA_MEASUREMENT_ID });
}

// --- Named convenience helpers for the four required custom events ---

export const trackContactFormStarted = (formId = "lead_form") =>
  trackEvent("contact_form_started", { form_id: formId });

export const trackContactFormSubmitted = (formId = "lead_form", extra = {}) =>
  trackEvent("contact_form_submitted", { form_id: formId, ...extra });

export const trackClickToCall = (phone, source = "site") =>
  trackEvent("click_to_call", { phone_number: phone, source });

export const trackAttorneyContactClicked = (source = "attorney_card", extra = {}) =>
  trackEvent("attorney_contact_clicked", { source, ...extra });
